<template>
    <div class="changename">
        <el-tabs v-model="activeName" @tab-click="handleClick" type="card">
            <el-tab-pane label="修改名称" name="changeName">
                <div v-if="isShow">
                    <el-form :model="submitForm" label-width="200px" :rules="rules" ref="submitForm" class="supplier-form">
                        <el-form-item label="原公司名称：">
                            <el-input type="text" v-model="basic.fnameL2" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item label="新公司名称：" prop="fnameL2">
                            <el-input type="text" v-model.trim="submitForm.fnameL2" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="上传附件：" prop="fileList">
                            <el-upload class="upload"
                                    :action="uploadApi"
                                    :on-success="handleChangeAchieve"
                                    :on-error="uploadError"
                                    :on-remove="handleRemoveAchieve"
                                    :before-remove="beforeRemove"
                                    :before-upload="beforeUpload"
                                    multiple
                                    :limit="3"
                                    :on-exceed="handleExceed">
                                <el-button size="small" type="primary">点击上传</el-button>
                                <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                                    <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                            </el-upload>
                        </el-form-item>
                        <el-form-item>
                            <el-button v-if="basicIsShow" type="primary" :disabled="$root.loading" @click="onSubmit">提交</el-button>
                        </el-form-item>
                    </el-form>
                    <div class="tip">
                        <div>附件需包含：</div>
                        <div>1、工商局出具的变更证明</div>
                        <div>2、新营业执照</div>
                    </div>
                </div>
                <div v-else class="content-main">
                    <div class="tipstitle_title">
                        <span >审批中</span>
                    </div>
                    <div class="item_line">
                        <span class="itemhead">原公司名称：</span>
                        <span>{{ basic.fnameL2 }}</span>
                    </div>
                    <div class="item_line">
                        <span class="itemhead">新公司名称：</span>
                        <span>{{ resultData.fnameL2 }}</span>
                    </div>

                    <table border strip class="info-table">
                        <tr>
                            <th>序号</th>
                            <th>附件名称</th>
                            <th>上传时间</th>
                            <th>操作</th>
                        </tr>
                        <tr v-for="(a, i) in resultData.fileList" :key="i">
                            <td>{{i+1}}</td>
                            <td>{{a.fileOldName}}</td>
                            <td>{{a.createDate}}</td>
                            <td><a :href="a.url">下载</a></td>
                        </tr>
                    </table>
                </div>
            </el-tab-pane>
            <el-tab-pane label="修改联系人信息" name="changeDefaultLink">
                <div v-if="isShowYewu">
                    <el-form :model="cahngeYewuForm" label-width="200px" :rules="rulesYewu" ref="cahngeYewuForm" class="supplier-form">
                        <el-form-item label="类型：">
                            <el-select v-model="personType" @change="personTypeChange" placeholder="请选择" style="float:left" ref="personType" >
                                <el-option
                                    v-for="type,i in  contactTypes.slice(0,2)"
                                    :key="i+''"
                                    :label="type"
                                    :value="i+''">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="personType=='0'" label="姓名：" prop="fpersonname">
                            <el-input  type="text" v-model.trim="cahngeYewuForm.fpersonname" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item v-else label="姓名：" prop="fpersonname">
                            <el-select @change="changeLinkPersons" v-model.trim="cahngeYewuForm.id" placeholder="单位">
                                <el-option v-for="o in supplierLinks" :label="o.fpersonname" :value="o.id" :key="o.id"></el-option>
                            </el-select>
                            <el-input  type="text" v-model.trim="cahngeYewuForm.fpersonname" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="身份证：" prop="idCard">
                            <el-input type="text" v-model.trim="cahngeYewuForm.idCard" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="手机：" prop="fphone">
                            <el-input type="text" v-model.trim="cahngeYewuForm.fphone" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="邮箱：" prop="femail">
                            <el-input type="text" v-model.trim="cahngeYewuForm.femail" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="上传附件：" prop="baseFiles">
                            <el-upload class="upload"
                                    :action="uploadApi"
                                    :on-success="handleChangeAchieveYewu"
                                    :on-error="uploadError"
                                    :on-remove="handleRemoveAchieveYewu"
                                    :before-remove="beforeRemove"
                                    :before-upload="beforeUpload"
                                    multiple
                                    :limit="3"
                                    :on-exceed="handleExceed">
                                <el-button size="small" type="primary">点击上传</el-button>
                                <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                                    <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                            </el-upload>
                        </el-form-item>
                        <el-form-item>
                            <el-button  type="primary" :disabled="$root.loading" @click="onSubmitYewu">提交</el-button>
                        </el-form-item>
                    </el-form>
                    <div class="tip">
                        <div>附件需包含：</div>
                        <div>1、变更说明（内容包含变更原因、原联系人和现联系人的姓名、手机号、身份证号、盖章）</div>
                        <div>2、现联系人近6个月社保缴纳记录</div>
                        <div>3、现联系人联系方式归属地证明</div>
                        <div>4、说明：所有资料均需要加盖公章，具体样式可通过供方平台-帮助中心-附件6 变更信息操作手册查阅</div>
                    </div>
                </div>
                <div v-else class="content-main">
                    <div class="tipstitle_title">
                        <span >审批中</span>
                    </div>
                    <div class="item_line" v-if="!!resultLink.fpersonname">
                        <span class="itemhead">姓&nbsp;&nbsp;名：</span>
                        <span>{{ resultLink.fpersonname }}</span>
                    </div>
                    <div class="item_line" v-if="!!resultLink.idCard">
                        <span class="itemhead">身份证：</span>
                        <span>{{ resultLink.idCard }}</span>
                    </div>
                    <div class="item_line" v-if="!!resultLink.fphone">
                        <span class="itemhead">手机号：</span>
                        <span>{{ resultLink.fphone }}</span>
                    </div>
                    <div class="item_line" v-if="!!resultLink.femail">
                        <span class="itemhead">邮箱：</span>
                        <span>{{ resultLink.femail }}</span>
                    </div>

                    <table border strip class="info-table">
                        <tr>
                            <th>序号</th>
                            <th>附件名称</th>
                            <th>上传时间</th>
                            <th>操作</th>
                        </tr>
                        <tr v-for="(a, i) in resultLink.baseFiles" :key="i">
                            <td>{{i+1}}</td>
                            <td>{{a.fileOldName}}</td>
                            <td>{{a.createDate}}</td>
                            <td><a :href="a.url">下载</a></td>
                        </tr>
                    </table>
                </div>
            </el-tab-pane>
        </el-tabs>

        
    </div>
</template>

<script type="text/babel">
    import { mapGetters, mapActions } from 'vuex'
    import util from '@/util'
    import { managerRules } from '@/util/rules'
    import apis from '@/store/apis'

    export default {
        name: 'changename',
        data () {
            return {
                personType: '0',
                submitForm: {
                    fnameL2: '',
                    fileList: []
                },
                uploadApi: `${util.baseUrl}rest/file/upload`,
                downloadUrl: `${util.baseUrl}rest/file/down`,
                rules: {
                    fnameL2: [
                        { required: true, message: '请输入供应商单位名称', trigger: 'blur' },
                        { validator: 'regexp', pattern: /^[\u4E00-\u9FA50-9A-Za-z（）() 、]+$/, message: '供应商名称只允许中英文（可包含括号、数字和空格）', trigger: 'blur'}
                        //{ min: 3, message: '至少 3 个字符', trigger: 'blur' }
                    ],
                    fileList: [
                        { required: true, message: '附件必须传入', trigger: 'blur' }
                    ]
                },
                resultData: {
                    fnameL2: '',
                    fileList: []
                },
                activeName: 'changeName',
                isShow: false, // true 显示修改名称信息  false 显示发起修改名称审批的信息
                isShowYewu: false, // true 显示修改业务对接人信息  false 显示发起业务对接人审批的信息
                cahngeYewuForm:{
                    id: '',
                    fpersonname: '',
                    idCard: '',
                    fphone: '',
                    femail: '',
                    baseFiles: []
                },
                rulesYewu: {
                    baseFiles: [
                        { required: true, message: '附件必须传入', trigger: 'blur' },
                    ],
                    fpersonname: [
                        { required: true, message: '姓名必须填写', trigger: 'blur' },
                        { pattern:  /^(?!.*[\s])/g,message:'请勿输入空格、回车等非法字符',trigger:'blur'}
                    ],
                    idCard: managerRules.idCard,
                    fphone: [
                        { required: true, message: '手机号必须填写', trigger: 'blur' },
                        { validator: 'regexp', pattern: /^1\d{10}$/, message: '手机号码不正确', trigger: 'blur' }
                    ],
                    femail: [
                        { required: true, message: '邮箱必须填写', trigger: 'blur' },
                        { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
                    ]
                },
                resultLink: {},
                basicIsShow: true,  // 判断信息是否修改
                supplierLinks:{}
            }
        },
        computed: {
            ...mapGetters(['basic','contactTypes']),
            oldLink() {
                return !!this.$store.getters['linkpersons'][0] ? this.$store.getters['linkpersons'][0] : {}
            }
        },
        methods: {
            ...mapActions(['getLinkPersons']),
            handleClick(val){
                this.cahngeYewuForm={
                    id: this.$store.getters['linkpersons'][0].id ? this.$store.getters['linkpersons'][0].id:'',
                    fpersonname: this.$store.getters['linkpersons'][0].fpersonname ? this.$store.getters['linkpersons'][0].fpersonname:'',
                    idCard:  this.$store.getters['linkpersons'][0].idCard ? this.$store.getters['linkpersons'][0].idCard:'',
                    fphone: this.$store.getters['linkpersons'][0].fphone ? this.$store.getters['linkpersons'][0].fphone:'',
                    femail: this.$store.getters['linkpersons'][0].femail ? this.$store.getters['linkpersons'][0].femail:'',
                    baseFiles: []
                }
            },
            handleChangeAchieve(response, file, fileList){
                this.submitForm.fileList = this.__getBaseFiles__(file,fileList)
            },
            handleChangeAchieveYewu(response, file, fileList){
                this.cahngeYewuForm.baseFiles = this.__getBaseFiles__(file,fileList)
            },
            uploadError(){
                this.$message({message:'上传出错，请稍后再试。',type:'error'});
            },
            handleRemoveAchieve(file, fileList) {
                this.submitForm.fileList = this.submitForm.fileList.filter(function(f){
                    return f.uid !== file.uid
                });
            },
            handleRemoveAchieveYewu(file, fileList) {
                this.cahngeYewuForm.baseFiles = this.cahngeYewuForm.baseFiles.filter(function(f){
                    return f.uid !== file.uid
                });
            },
            beforeRemove(file) {
                return this.$confirm(`确定移除 ${ file.name }？`);
            },
            personTypeChange(data) {
                this.getLinkPersonsByStockIdAndType()
            },
            beforeUpload(file){
                if(!util.allowUpload(file.name)){
                    this.$alert(`支持的文件类型：${util.acceptFileTypes.join(' | ')}`,'文件类型不支持，已取消上传！',{ type: 'error' })
                    return false
                }
                return true
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            __getBaseFiles__(file,fileList){
                let fs = [];
                fileList.forEach((item) => {
                    if(item.response){
                        let f = item.response.basefiles[0];
                        item.fileOldName = f.fileoldname;
                        item.name = f.fileoldname;
                        item.fileName = f.filename;
                        item.filePath = f.filepath;
                        item.fileSize = f.filesize;
                        item.fileType = f.filetype;
                        item.sort = f.sort;
                    }
                    fs.push(item);
                });
                return fs.filter(item => !!item.filePath)
            },
            getInitInfo () {
                return this.$http.get('/rest/api/completeFourInfo/getChangeNameInfo').then((res) => {
                    if (res.data.result) {
                        if (res.data.value) {
                            this.isShow = false
                            this.resultData = res.data.value
                            if (this.resultData && this.resultData.fileList) {
                                this.resultData.fileList.forEach(item => {
                                    item.url = `${this.downloadUrl}?fileName=${item.fileName}&fileOldName=${encodeURIComponent(item.fileOldName)}`
                                })
                            }
                        } else {
                            this.isShow = true // 填写页面显示
                        }
                    } else {
                        this.$message({message: res.data.message, type:'error'})
                    }
                })
            },
            getLinkPersonsByStockIdAndType(){
                let that = this
                let params = {
                    fparentid: that.$root.stockId,
                    personType: that.personType
                }
                this.$http.post('rest/api/completeFourInfo/getLinkPersonsByStockIdAndType',params).then((res) => {
                    if (res.data.result) {
                        that.supplierLinks = res.data.value
                        if(that.supplierLinks.length>0){
                            that.cahngeYewuForm.id = that.supplierLinks[0].id
                            that.cahngeYewuForm.fpersonname = that.supplierLinks[0].fpersonname
                            that.cahngeYewuForm.idCard = that.supplierLinks[0].idCard
                            that.cahngeYewuForm.fphone = that.supplierLinks[0].fphone
                            that.cahngeYewuForm.femail = that.supplierLinks[0].femail
                        }else{
                            this.personType = '0'
                        }
                    }
                })
            },
            getLinkPersonsById(id){
                let that = this;
                this.$http.post('rest/api/completeFourInfo/getLinkPersonDetail',id).then((res) => {
                    if (res.data.result) {
                        let cur = res.data.value
                        that.cahngeYewuForm.id = cur.id
                        that.cahngeYewuForm.fpersonname = cur.fpersonname
                        that.cahngeYewuForm.idCard = cur.idCard
                        that.cahngeYewuForm.fphone = cur.fphone
                        that.cahngeYewuForm.femail = cur.femail
                    }
                })
            },
            onSubmit () {
                this.$refs.submitForm.validate(valid=>{
                    if (valid) {
                        this.$root.loading = true
                        this.$http.post('/rest/api/checkUserInfo/changeName', this.submitForm).then(res => {
                            if (res.data.result) {
                                this.isShow = false
                                this.$alert(res.data.message)
                                this.getInitInfo()
                                this.$root.loading = false
                            } else {
                                this.$root.loading = false
                                this.$alert(res.data.message)
                            }
                        })
                    } else {
                        this.$root.loading = false
                    }
                })
            },
            getLinkInfo () {
                return this.$http.get('/rest/api/completeFourInfo/getChangeDefaultLink').then((res) => {
                    if (res.data.result) {
                        if (res.data.value) {
                            this.isShowYewu = false
                            this.resultLink = res.data.value
                            if (this.resultLink && this.resultLink.baseFiles) {
                                this.resultLink.baseFiles.forEach(item => {
                                    item.url = `${this.downloadUrl}?fileName=${item.fileName}&fileOldName=${encodeURIComponent(item.fileOldName)}`
                                })
                            }
                        } else {
                            this.isShowYewu = true // 填写页面显示
                        }
                    } else {
                        this.$message({message: res.data.message, type:'error'})
                    }
                })
            },
            onSubmitYewu () {
                this.$refs.cahngeYewuForm.validate(valid=>{
                    if (valid) {
                        this.$root.loading = true
                        this.$http.post('/rest/api/checkUserInfo/changeLink', this.cahngeYewuForm).then(res => {
                            if (res.data.result) {
                                this.isShowYewu = false
                                this.$alert(res.data.message)
                                this.getLinkInfo()
                                this.$root.loading = false
                            } else {
                                this.$root.loading = false
                                this.$alert(res.data.message)
                            }
                        })
                    } else {
                        this.$root.loading = false
                    }
                })
            },
            changeLinkPersons(data){
                this.getLinkPersonsById(data)
            }
        },
        created(){
            Promise.all([this.getInitInfo(),
                this.getLinkInfo(),
                this.getLinkPersons()
            ]).then(r=>{

            })
        },
        mounted(){
            this.basicIsShow = window.sessionStorage.getItem('basicIsShow')
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .content-main{
        border: 1px solid #d9d9d9;
        min-height: 300px;
    }
    .tipstitle_title{
        border: 1px solid #d9d9d9;
        border-width: 0px 0px 1px 0px; 
        font: normal 18px Verdana,"Microsoft YaHei";
        padding-left: 10px;
        background-color: #d9d9d9;
        height: 30px;
    }
    .item_line {
        overflow: hidden;
        zoom: 1;
        clear: both;
        margin: 11px 3px;
        padding: 10px 0;
    }
    .item_line .itemhead {
        float: left;
        margin-left: 10px;
        width: 120px;
    }
     .tip{
        margin-left: 100px;
        font-size:12px;
        line-height: 22px;
        color:#999;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dsp/supplier/Changename.vue